var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('v-chip',{staticClass:"ma-0 white--text font-weight-bold",class:['lb-info', 'lb-primary'][_vm.cardapio_digital ? 0 : 1],staticStyle:{"font-size":"9px"},attrs:{"small":"","label":_vm.label}},[_vm._v(_vm._s(_vm.cardapio_digital ? 'Cardápio Digital' : 'Bigou Delivery'))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }